(() => {
  // Predictive search results only carry the featured image, so search cards
  // show no hover image. Collection and homepage cards pick their hover image
  // automatically in snippets/ab-card-hover-media.liquid.
  window.abCardHover = () => null;
})();

// Klaviyo Reviews: hide star ratings that read "0 reviews" until a product has
// its first review, so empty stars don't appear on cards or under titles.
(() => {
  const zero = /^\s*(0|no)\s+reviews?\s*$/i;
  const check = (root) => {
    (root.querySelectorAll ? root : document).querySelectorAll('.klaviyo-star-rating-widget').forEach((el) => {
      const txt = (el.innerText || '').trim();
      if (!txt) return;
      const hide = zero.test(txt);
      el.classList.toggle('ab-stars-empty', hide);
      const link = el.closest('.ab-pdp-stars');
      if (link) link.classList.toggle('ab-stars-empty', hide);
    });
  };
  const start = () => {
    check(document);
    new MutationObserver(() => check(document)).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
